import App from 'antd/es/app';
import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import styled from 'styled-components';

import type { Conversation } from '@mai/types';

import { createConversation } from '@queries/conversations';

type FormValues = {
  title: string;
  description?: string;
};

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CreateProjectConversationForm = ({
  projectId,
  afterSubmit,
  confirmText = 'Create Conversation',
}: {
  projectId: string;
  afterSubmit: (conversation: Conversation) => void;
  confirmText?: string;
}) => {
  const [form] = Form.useForm();
  const { message } = App.useApp();

  const onFinish = async (values: FormValues) => {
    const loading = message.loading('Creating conversation...');
    try {
      const conversation = await createConversation({
        projectId,
        type: 'project',
        title: values.title ?? 'New Conversation',
        description: values.description ?? null,
      });
      loading();
      afterSubmit(conversation);
    } catch (error) {
      loading();
      void message.error('Failed to create conversation');
    }
  };

  return (
    <FormContainer>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="title"
          label="Title (optional)"
          rules={[{ required: false }]}
        >
          <Input placeholder="Enter conversation title..." />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description (optional)"
          rules={[{ required: false }]}
        >
          <Input.TextArea placeholder="Enter conversation description..." />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            {confirmText}
          </Button>
        </Form.Item>
      </Form>
    </FormContainer>
  );
};

export default CreateProjectConversationForm;
